import { styled } from '@zenbusiness/zui/styles';

// TODO: replace with zui when package is ready
import MobileStepper from '@mui/material/MobileStepper';

export const MobileStepperStyled = styled(MobileStepper)(({ theme }) => ({
  justifyContent: 'center',
  gap: 52,
  padding: '0 4px',
  margin: '0 4px',
  backgroundColor: 'transparent',
  '& .MuiMobileStepper-dotActive': {
    backgroundColor: theme.palette.fixed.black
  }
}));
